module.exports = __webpack_public_path__ + "static/img/icon-医院@3x.80c91f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ncp/icon-医院@3x.png
// module id = 122
// module chunks = 14 379 380